module.exports = __webpack_public_path__ + "static/media/guestcentric.332d68d1.ico";